export const HowToPlayPropaganda = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1200 300"
      width="100%"
      preserveAspectRatio="xMidYMid meet"
    >
      <style>
        {`
          text {
            font-family: "Comic Sans MS", "Arial Rounded MT Bold", "Trebuchet MS", sans-serif;
            font-weight: 900;
            fill: white;
            stroke: black;
            stroke-width: 14px;
            paint-order: stroke fill;
          }
        `}
      </style>

      {/* Line 1 */}
      <text
        x="50%"
        y="45%"
        textAnchor="middle"
        fontSize="120"
        textLength="1000"
        lengthAdjust="spacingAndGlyphs"
      >
        How to Play
      </text>

      {/* Line 2 */}
      <text
        x="50%"
        y="80%"
        textAnchor="middle"
        fontSize="140"
        textLength="1000"
        lengthAdjust="spacingAndGlyphs"
      >
        Propaganda
      </text>
    </svg>
  );
};
